exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-top-1em .btn-primary {\n  min-width: 150px;\n}\n", ""]);

// exports
